// PLUGINS IMPORTS //
import React from "react"
import { Element } from "react-scroll"
import styled from "styled-components/macro"

// COMPONENTS IMPORTS //
import TitleSection from "./TitleSection/TitleSection"
import ImageSection from "./ImageSection/ImageSection"
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //
import Background from "Content/Screens/GeneralScreens/HomeScreen/Background/Background"
import { iPhoneResolution } from "Content/Shared/Styles/Theme"

/////////////////////////////////////////////////////////////////////////////

type PropsType = {}

const IntroSection: React.FC<PropsType> = () => {
  return (
    <Element name={"HOME"}>
      <Background />
      <ContentWrapper>
        <TitleSection />
        <ImageSection />
      </ContentWrapper>
    </Element>
  )
}

/////////////////////////////////////////////////////////////////////////////

const ContentWrapper = styled.div`
  max-width: 1434px;
  margin: 0 auto;
  padding: 300px 200px 0px 0px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;

  @media (max-width: ${iPhoneResolution}px) {
    flex-direction: column;
    padding: 100px 20px 250px 30px;
    align-items: center;
  }
`

export default React.memo(IntroSection, memoComparison)
